import React from 'react';

export interface ContextMenuContext<T> {
   anchorEl: null | HTMLElement;
   handleClick: (data: T) => (event: React.MouseEvent<HTMLElement>) => void | boolean;
   data: T;
   handleClose: (ev?: any) => void;
}

export function buildContextDefaultValue<T>() {
   return {
      data: {} as T,
      anchorEl: null,
      handleClose: () => {
         console.error('handleClose is not provided');
      },
      handleClick: (data: T) => (ev: React.MouseEvent<HTMLElement>) => {
         console.error('handleClick is not provided');
      },
   } as ContextMenuContext<T>;
}

export function createMenuContext<T>() {
   const defaultContext = buildContextDefaultValue<T>();
   return React.createContext(defaultContext);
}
